import { createdATFilter } from 'modules/common/constants';

export const keywordFilters = [createdATFilter];
